require('./depositMoneyStep2.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
// @ commons
const { FormattedText, formatText } = require('core/i18n').i18n;
// @ constants
const { CARD_DEPOSIT_MONEY_ID } = require('constants/operationTypes');
const { CARD_DEPOSIT_MONEY_ID_CC } = require('constants/contactCenter/operationTypes');
const { API_ENTERPRISE_NUMBER, API_CENTER } = require('constants/index');
// @ components
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const {
    ConfirmationScript,
    CONFIRMATION_SCRIPT_GREETING,
    CONFIRMATION_SCRIPT_AGREEMENT
} = require('components/contactCenter/confirmScript/confirmationScript');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
// @utilities
const { nonNumericFilter } = require('utilities/stringHelper');
const { getFormattedString } = require('utilities/currencyHelper');

class DepositMoneyStep2 extends React.Component {
    render() {
        const { immCardDepositMoney, immCard } = this.props;
        const productNumber = immCard.getIn(['contract', 'product']);
        const contractNumber = immCard.getIn(['contract', 'number']);
        const amount = immCardDepositMoney.get('amount');
        const currency = immCardDepositMoney.get('currency');
        const operationParams = {
            ammount: amount,
            currency,
            'originAccount': `${API_ENTERPRISE_NUMBER}${API_CENTER}${productNumber}${contractNumber}`,
            'pan': nonNumericFilter(immCard.get('number'))
        };

        const confirmationWarningText = immCard.get('isViaT') ? 'cardDepositMoney-confirmationWarningViaT': 'cardDepositMoney-confirmationWarning';
        const injectedStrings = [
            getFormattedString({amount, currency})
        ];
        const operative = formatText('operatives-cardIncome');

        return (
            <article className="deposit-money-step-two">
                <header className="deposit-money-step-two__header">
                    <FormattedText value="cardDepositMoney-securityConfirmation" className="deposit-money-step-two__title" />
                </header>
                <ContactCenterRender>
                    <ConfirmationScript
                        operative={operative}
                        confirmationType={CONFIRMATION_SCRIPT_GREETING}
                    />
                </ContactCenterRender>
                <section className="deposit-money-step-two__content">
                    <FormattedText
                        value={confirmationWarningText}
                        className="deposit-money-step-two__subtitle"
                        injectedStrings={injectedStrings}
                    />
                    <ContactCenterRender>
                        <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                    </ContactCenterRender>
                    <SignaturePattern
                        operationType={!__CONTACT_CENTER__ ? CARD_DEPOSIT_MONEY_ID : CARD_DEPOSIT_MONEY_ID_CC}
                        operationParams={operationParams}
                    />
                </section>
            </article>
        )
    }
}

DepositMoneyStep2.propTypes = {
    immCardDepositMoney: PropTypes.object.isRequired,
    immCard: PropTypes.object.isRequired
};

module.exports = DepositMoneyStep2;